import React, { useState } from 'react';
import HemaLogo from '../assets/images/HematogenixRed.svg';
import LoginForm from '../components/ClientPortal/login';
import SettingForm from '../components/auth/selectSettings';
import AuthLanding from '../components/auth/authLanding';
const PortalLogin = () => {
  const [firstAttemptToSelectDropdown, setFirstAttemptToSelectDropdown] = useState(false);
  console.log('firstAttemptToSelectDropdown', firstAttemptToSelectDropdown);
  return (
    <div className="flex w-full">
      {!!firstAttemptToSelectDropdown ? <AuthLanding className="bg-[url(../../assets/images/bg-login-resting.png)]" /> : <AuthLanding bg />}
      <div className="p-7 lg:pl-[70px] w-full lg:w-[50%] min-h-screen lg:min-h-auto bg-hemaSecondary">
        <div className="mt-8 lg:mt-[60px] mb-[104px]">
          <img src={HemaLogo} alt="Company logo" />
        </div>
        {!!firstAttemptToSelectDropdown ? <SettingForm /> : <LoginForm setFirstAttemptToSelectDropdown={setFirstAttemptToSelectDropdown} />}
      </div>
    </div>
  );
};

export default PortalLogin;
